import { LogoutOutlined } from "@ant-design/icons";
import { Button, Result, Tooltip } from "antd";
import logo from "../../assets/images/logoGF.png";
import React, { useState } from "react";
import ConfirmationModal from "../../components/modal/ConfirmationModal";
import { useDispatch } from "react-redux";
import { logout } from "../../features/AuthSlice";
import { userDetails } from "../../features/UserSlice";
import { Navigate } from "react-router-dom";

function PositionNotFound() {
  const [logoutModal, setLogoutModal] = useState(false);
  const dispatch = useDispatch();
  function logoutNow() {
    // 🔑 NEW: Clear all filters on logout
    sessionStorage.removeItem('topPlansFilters');
    
    localStorage.setItem("authToken", "");
    localStorage.setItem("authUser", "");
    dispatch(logout());
    dispatch(userDetails({}));
    Navigate("/login");
  }
  return (
    <>
      <div className="fixed flex w-full justify-between bg-white py-4 px-6 z-50 top-0 shadow">
        <div className="pri-font text-2xl">
          <img className="w-40" src={logo} alt="Logo" />
        </div>
        <Tooltip title={"Logout"}>
          <Button onClick={() => setLogoutModal(true)}>
            <LogoutOutlined />
          </Button>
        </Tooltip>
      </div>
      <div className="h-full flex items-center justify-center">
        <Result
          status="404"
          title="Position not assigned. Contact your admin"
        />
      </div>
      <ConfirmationModal
        title="Logout"
        text="Are you sure want to logout?"
        handleCancel={() => setLogoutModal(false)}
        visible={logoutModal}
        handleOk={() => logoutNow()}
      />
    </>
  );
}

export default PositionNotFound;
